import {Qualtrics_Identifier} from '../config';

const QUALTRICS_ID = Qualtrics_Identifier;
const QUALTRICS_SUBDOMAIN = `${Qualtrics_Identifier}`
  .toLowerCase()
  .replace(/_/g, '');

const getCspNonce = () =>
  document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

export const initQualtrics = (extrnalRefId: string) => {
  if (!QUALTRICS_ID) return;


  (window as any).QSI = (window as any).QSI || {};
  (window as any).QSI.config = (window as any).QSI.config || {};
  (window as any).QSI.global = (window as any).QSI.global || {};
  (window as any).QSI.config.externalReference = extrnalRefId;
  (window as any).QSI.config.enableSecureVariables = true;
  (window as any).QSI.global.enableJSSanitization = true;

  if (typeof window === 'undefined') return;
  if ((window as any).__QUALTRICS_INITIALIZED__) return;
  (window as any).__QUALTRICS_INITIALIZED__ = true;

  

  const cspNonce = getCspNonce();

  const container = document.createElement('div');
  container.id = QUALTRICS_ID;
  document.body.appendChild(container);

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://${QUALTRICS_SUBDOMAIN}-consilio.siteintercept.qualtrics.com/SIE/?Q_ZID=${QUALTRICS_ID}`;

  if (cspNonce) {
    script.setAttribute('nonce', cspNonce);
  }

  script.onload = () => {
    const g = (window as any).QSI && (window as any).QSI.API;
    if (g) {
      g.run();
    }
  };

  document.body.appendChild(script);
};
